import { ETheme } from "@/DependenciesV9";
import { Hamburger, HamburgerProps } from "@fluentui/react-nav-preview";

interface HamburgerCustomProps {
  rcName?: string;
  theme?: ETheme;
}

const HamburgerCustom = (props: HamburgerProps & HamburgerCustomProps) => {
  return <Hamburger {...props}/>
};

export default HamburgerCustom;